"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var challenge_1 = require("../ts/components/card/challenge");
var history_1 = require("../ts/components/history/history");
function socketConnector(assets, store, server) {
    var conn = null;
    conn = window['io'].connect(server);
    conn.on('history', function (data) {
        var history = new history_1.default();
        history.renderFromSocket(Object.values(data.ChallengeHistory));
    });
    conn.on('data', function (data) {
        challenge_1.default.render(data.Challenge, assets, store);
    });
}
exports.socketConnector = socketConnector;
;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/js/socket-connector.ts
// module id = 1995
// module chunks = 4